/*global Modernizr, trapFocus, Splide, console, TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag */
/*jslint browser:true */

(function() {
  'use strict';

  var staff_modal_containers = document.querySelectorAll('.staff-modal-container'),
      open_trigger = false;

  if(staff_modal_containers) {
    staff_modal_containers.forEach((staff_modal_container) => {
      const staff_modal_triggers = document.querySelectorAll('.js-staff-modal-trigger'),
            staff_modal = staff_modal_container.querySelector('.staff-modal'),
            staff_slider = staff_modal_container.querySelector('.staff-slider'),
            modal_close = staff_modal_container.querySelector('.modal-close'),
            slider = new Splide(staff_slider, {
              type: 'slide',
              arrows: 'slider',
              pagination: false
            });

      slider.mount({ TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag });

      setupTriggers(staff_modal_triggers, slider);

      trapFocus(staff_modal);

      staff_modal_container.addEventListener('click', function(e) {
        document.body.classList.remove('staff-modal-open');
        staff_modal_container.classList.remove('open');

        if(open_trigger) {
          open_trigger.focus();
          open_trigger = false;
        }
      });

      staff_modal.addEventListener('keydown', (e) => {
        if(e.code === 'Escape') {
          document.body.classList.remove('staff-modal-open');
          staff_modal_container.classList.remove('open');

          if(open_trigger) {
            open_trigger.focus();
            open_trigger = false;
          }

          return;
        }

        if(e.key === 'Home') {
          slider.go(0);
          return;
        }

        if(e.key === 'End') {
          slider.go(slider.length);
          return;
        }

        if(e.key === 'ArrowRight') {
          slider.go('>');
          return;
        }

        if(e.key === 'ArrowLeft') {
          slider.go('<');
          return;
        }
      });

      staff_modal.addEventListener('click', function(e) {
        e.stopPropagation();
      });

      modal_close.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        document.body.classList.remove('staff-modal-open');
        staff_modal_container.classList.remove('open');

        if(open_trigger) {
          open_trigger.focus();
          open_trigger = false;
        }
      });
    });
  }

  function setupTriggers(staff_modal_triggers, slider) {
    staff_modal_triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        var modal_container = document.getElementById(trigger.getAttribute('data-modal'));

        document.body.classList.remove('mobile-menu-open');
        document.body.classList.add('staff-modal-open');
        modal_container.classList.add('open');
        open_trigger = trigger;

        var slide_index = trigger.getAttribute('data-index');

        slider.go(parseInt(slide_index));
      });
    });
  }
}());